export default __webpack_public_path__ + "static/media/rankingheader.abef5030.png";